import { Route, Routes } from 'react-router-dom';

import { LayoutRegGuideV1 } from './layout-reg-guide-v1';
import { LayoutPrimary } from './layout-primary';
import { LayoutRegGuide } from './layout-reg-guide/layout-reg-guide';
import { Login } from './login';
import { ResetPassword } from './reset-password';
import { Profile } from './profile';
import { Registration } from './registration';
import { LandingPage } from './landing-page';
import { CookieBanner } from './cookie-banner';
import { MyLenses } from './my-lenses';
import { MyBonuses } from './my-bonuses';
import { PointsHowTo } from './points-how-to';
import { CookiePolicy } from './cookie-policy';
import { PageNotFound } from './page-not-found';
import { Program } from './program';
import { EcpLocator } from './ecp-locator';
import { Appointment } from './appointment/appointment.container';
import { InternalLinks } from '../../../constants/internal-links';
import { VisionProfile, VisionProfilePage } from './vision-profile';
import { usePrivateRoute } from '../../../hooks/use-private-route';
import { AppLevelModals } from './app-level-modals';
import { MyOrdersPage } from './order/my-orders-page';
import { OrderCreatePage } from './order/order-create-page';
import { RegGuidePage } from './reg-guide-page';
import { RegGuidePageNew } from './reg-guide-page-new';
import { ProfileDelete } from './profile-delete';
import { EcpLocatorExternal } from './ecp-locator-external';
import { MyAcuvueIdContainer } from './my-acuvue-id/my-acuvue-id.container';
import { ArlPage } from './arl-page';
import { BrandPageVision } from './brand-pages/vision';
import { BrandPageComfort } from './brand-pages/comfort';
import { BrandPageUv } from './brand-pages/uv';
import { BrandPageMaxComfort } from './brand-pages/max-comfort';
import { BrandPageClarity } from './brand-pages/clarity';
import { BrandPageMaxUv } from './brand-pages/max-uv';
import { Brand1 } from './brand-pages/facts-about-brand/brand1';
import { BrandPopularity } from './brand-pages/facts-about-brand/brand-popularity';
import { BrandTrust } from './brand-pages/facts-about-brand/brand-trust';
import { BrandUv } from './brand-pages/facts-about-brand/brand-uv';
import { BrandComfort } from './brand-pages/facts-about-brand/brand-comfort';
import { OnlineShops } from './online-shops';
import { Aom1dSimulator } from './simulators';
import { YesNo } from './brand-pages/yes-no';
import { Facts } from './facts';
import { Unsubscribe } from './unsubscribe';

export const App = (): JSX.Element => {
  const { getPrivateElement } = usePrivateRoute();

  return (
    <>
      <Routes>
        <Route element={<LayoutPrimary />}>
          <Route path="/" element={<LandingPage />} />
          <Route path={InternalLinks.cookiePage} element={<CookiePolicy />} />
          <Route path={InternalLinks.programPage} element={<Program />} />
          <Route path={InternalLinks.ecpLocator} element={<EcpLocator />} />
          <Route path={InternalLinks.profilePage} element={getPrivateElement(<Profile />)} />
          <Route path={InternalLinks.myLensesPage} element={getPrivateElement(<MyLenses />)} />
          <Route path={InternalLinks.myBonusesPage} element={getPrivateElement(<MyBonuses />)} />
          <Route path={InternalLinks.pointsHowToPage} element={getPrivateElement(<PointsHowTo />)} />
          <Route path={InternalLinks.appointment} element={getPrivateElement(<Appointment />)} />
          <Route path={InternalLinks.myOrdersPage} element={getPrivateElement(<MyOrdersPage />)} />
          <Route path={InternalLinks.orderCreate} element={getPrivateElement(<OrderCreatePage />)} />
          <Route path={InternalLinks.onlineShops} element={<OnlineShops />} />
          <Route path={InternalLinks.deleteAccount} element={<ProfileDelete />} />
          <Route path={InternalLinks.simulatorAom1d} element={<Aom1dSimulator />} />
          <Route path={InternalLinks.regGuideNew} element={<RegGuidePageNew />} />
          <Route path="*" element={<PageNotFound />} />
        </Route>
        <Route element={<LayoutPrimary isBackground />}>
          <Route path={InternalLinks.login} element={<Login />} />
          <Route path={InternalLinks.registration} element={<Registration />} />
          <Route path={InternalLinks.resetPassword} element={<ResetPassword />} />
          <Route path={InternalLinks.visionProfileSurvey} element={<VisionProfile />} />
          <Route path={InternalLinks.visionProfile} element={getPrivateElement(<VisionProfilePage />)} />
        </Route>
        <Route element={<LayoutRegGuide />}>
          <Route path={InternalLinks.arl} element={<ArlPage />} />
        </Route>
        <Route element={<LayoutRegGuideV1 />}>
          <Route path={InternalLinks.regGuide} element={<RegGuidePage />} />
        </Route>
        <Route path={InternalLinks.ecpLocatorExternal} element={<EcpLocatorExternal />} />
        <Route path={InternalLinks.brandVision} element={<BrandPageVision />} />
        <Route path={InternalLinks.brandMaxComfort} element={<BrandPageMaxComfort />} />
        <Route path={InternalLinks.brandUv} element={<BrandPageUv />} />
        <Route path={InternalLinks.brandComfort} element={<BrandPageComfort />} />
        <Route path={InternalLinks.brandClarity} element={<BrandPageClarity />} />
        <Route path={InternalLinks.brandMaxUv} element={<BrandPageMaxUv />} />
        <Route path={InternalLinks.presbyopiaYes} element={(<YesNo isYes eyeKey="presbyopia" />)} />
        <Route path={InternalLinks.presbyopiaNo} element={(<YesNo eyeKey="presbyopia" />)} />
        <Route path={InternalLinks.astigmatismYes} element={(<YesNo isYes eyeKey="astigmatism" />)} />
        <Route path={InternalLinks.astigmatismNo} element={(<YesNo eyeKey="astigmatism" />)} />
        <Route path={InternalLinks.myopiaYes} element={(<YesNo isYes eyeKey="myopia" />)} />
        <Route path={InternalLinks.myopiaNo} element={(<YesNo eyeKey="myopia" />)} />x
        <Route path={InternalLinks.brand1} element={<Brand1 />} />
        <Route path={InternalLinks.brandsComfort} element={<BrandComfort />} />
        <Route path={InternalLinks.brandPopularity} element={<BrandPopularity />} />
        <Route path={InternalLinks.brandTrust} element={<BrandTrust/>} />
        <Route path={InternalLinks.brandsUv} element={<BrandUv />} />
        <Route path={InternalLinks.facts} element={<Facts />} />
        <Route path={InternalLinks.unsubscribe} element={<Unsubscribe />} />
      </Routes>
      {location.pathname !== InternalLinks.ecpLocatorExternal && (
        <>
          <CookieBanner />
          <AppLevelModals />
        </>
      )}
      <MyAcuvueIdContainer />
    </>
  );
};
